import { SettingFilled } from '@ant-design/icons';
import { Table } from 'antd';
import qs from 'qs';
import { useEffect, useState } from 'react';
import { get } from "../Libraries/Ajax/HttpService";
import { useDistrict } from "../utils/DistrictContext";
const columns = [
    {
        title: 'Meter',
        dataIndex: 'Meter',
        key: 'Meter',
        children: [
            {
                title: 'Account',
                dataIndex: 'overided_name',
                key: 'overided_name',
                width: '10%',


                sorter: true,

            },

            {
                title: 'Meter ID',
                dataIndex: 'meter_id',
                key: 'meter_id',
                width: '5%',
                sorter: true,
            },
            {
                title: 'Register',
                dataIndex: 'register_number',
                key: 'register_number',
                width: '5%',
                sorter: true,
            },

            {
                title: 'Category',
                dataIndex: 'service_name',
                key: 'service_name',
                width: '7%',
                sorter: true,
            },
            {
                title: 'Mean',
                dataIndex: 'mean_meter',
                key: 'mean_meter',
                width: '4%',
                sorter: true,
            },
            {
                title: 'Standard Deviation',
                dataIndex: 'stddev_meter',
                key: 'stddev_meter',
                width: '8%',
                sorter: true,
            },
        ]
    },
    {
        title: 'Outlier',
        dataIndex: 'Outlier',
        key: 'Outlier',
        children: [
            {
                title: 'Time',
                dataIndex: 'flow_time',
                key: 'flow_time',
                width: '8%',
                sorter: true,

            },

            {
                title: 'Value ',
                dataIndex: 'flow',
                key: 'flow',
                width: '6%',
                sorter: true,
            },
            {
                title: 'Standard Score',
                dataIndex: 'standard_score',
                key: 'standard_score',
                width: '8%',
                sorter: true,
            },

            {
                title: 'Standard Score(Absolute)',
                dataIndex: 'absolute_standard_score',
                key: 'absolute_standard_score',
                width: '10%',
                sorter: true,
            },

            // {
            //     title: 'Manually Excluded',
            //     dataIndex: 'manually_excluded',
            //     key: 'manually_excluded',
            //     width: '10%',
            //     render: (_, record) => (

            //         <Checkbox checked={record.manually_excluded} disabled={true} />



            //     )

            // },
        ],
    },
];


function Outliersnew(datas) {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [field, setField] = useState();
    const [order, setOrder] = useState();
    const { selectedDistrict } = useDistrict();
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const getRandomuserParams = (params) => ({
        page_limit: params.pagination?.pageSize,
        page: params.pagination?.current,
        sort_field: field,
        sort_type: order,
        ...params,
    });
    const fetchData = () => {
        // setData(null);
        setLoading(true);
        if (datas.data.defaultOption == "Custom" && datas.data.parameterone != undefined && datas.data.parametertwo != undefined) {
        get(`apis/outliers/new?option=${datas.data.defaultOption}&minimum_score=${datas.data.slvalue}&start_date=${datas.data.parameterone}&end_date=${datas.data.parametertwo}&${qs.stringify(getRandomuserParams(tableParams))}`)


            .then((res) => {
                console.log(res.data.outliers_by_meter);
                setData(res?.data?.outliers_by_meter);
                
                setTableParams({
                    ...tableParams,
                    pagination: {
                        ...tableParams.pagination,
                        total: res.data.outliers_count,

                    },
                });
                setLoading(false);
            });
            
    }
    else{
        get(`apis/outliers/new?option=${datas.data.defaultOption}&minimum_score=${datas.data.slvalue}&${qs.stringify(getRandomuserParams(tableParams))}`)


        .then((res) => {
            console.log(res.data.outliers_by_meter);
            setData(res?.data?.outliers_by_meter);
            
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: res.data.outliers_count,

                },
            });
            setLoading(false); 
        });  
        
    }
    // setLoading(false);
    }
   
    useEffect(() => {
        fetchData();
    }, [datas.data.parameterone, datas.data.parametertwo, datas.data.defaultOption, datas.data.slvalue, JSON.stringify(tableParams.pagination.current),JSON.stringify(tableParams.pagination.pageSize),JSON.stringify(tableParams.column),JSON.stringify(tableParams.order),selectedDistrict]);
    const handleTableChange = (pagination, filters, sorter) => {
        console.log(sorter);
        setField(sorter.field);
        setOrder(sorter.order);
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
        console.log(tableParams);
        // `dataSource` is useless since `pageSize` changed
        if (pagination.pageSize !== tableParams.pagination?.pageSize) {
            setData([]);
        }
    };
    return (
        <Table
            columns={columns}
            className="styleRemove  over-view" columnWidth={10} scroll={{
                x: 2000,
                y: 500,
            }}
            //   rowKey={(record) => record.login.uuid}
            dataSource={data}
            pagination={tableParams.pagination}
            loading={loading}
            onChange={handleTableChange}
        />
    );
};
export default Outliersnew;